import { deleteData, getData, patchData, postData } from "../api/api";

export type PiiMaskStrategy = "REDACT" | "HASH" | "PARTIAL";

export type PiiRule = {
  id?: string;
  fieldPattern: string;
  strategy?: PiiMaskStrategy;
  indexName?: string;
  active?: boolean;
  description?: string;
};

export type IngestIndexGrant = {
  id?: string;
  indexName: string;
  environment?: "STAGING" | "PRODUCTION";
  allowedRoles?: string[];
  active?: boolean;
};

export type IndexSchema = {
  id?: string;
  indexName: string;
  jsonSchema?: string;
  version?: number;
  active?: boolean;
};

export const adminIngestService = {
  listPiiRules: () => getData("/admin/pii-rules") as Promise<PiiRule[]>,
  createPiiRule: (rule: PiiRule) => postData("/admin/pii-rules", rule) as Promise<PiiRule>,
  updatePiiRule: (id: string, rule: Partial<PiiRule>) =>
    patchData(`/admin/pii-rules/${id}`, rule) as Promise<PiiRule>,
  deletePiiRule: (id: string) => deleteData(`/admin/pii-rules/${id}`),
  previewPii: (sample: string, strategy: PiiMaskStrategy) =>
    postData("/admin/pii-rules/preview", { sample, strategy }) as Promise<{ masked: string }>,

  listGrants: () => getData("/admin/ingest-grants") as Promise<IngestIndexGrant[]>,
  createGrant: (grant: IngestIndexGrant) =>
    postData("/admin/ingest-grants", grant) as Promise<IngestIndexGrant>,
  updateGrant: (id: string, grant: Partial<IngestIndexGrant>) =>
    patchData(`/admin/ingest-grants/${id}`, grant) as Promise<IngestIndexGrant>,
  deleteGrant: (id: string) => deleteData(`/admin/ingest-grants/${id}`),

  listSchemas: () => getData("/admin/index-schemas") as Promise<IndexSchema[]>,
  createSchema: (schema: IndexSchema) =>
    postData("/admin/index-schemas", schema) as Promise<IndexSchema>,
  updateSchema: (id: string, schema: Partial<IndexSchema>) =>
    patchData(`/admin/index-schemas/${id}`, schema) as Promise<IndexSchema>,
  deleteSchema: (id: string) => deleteData(`/admin/index-schemas/${id}`),

  syncIndexRegistry: () =>
    postData("/admin/ingest-grants/sync-index-registry", {}) as Promise<{ syncedJobs: number }>,
};
